import { render, staticRenderFns } from "./CardBankrollReduction.vue?vue&type=template&id=1991d7c6"
import script from "./CardBankrollReduction.js?vue&type=script&lang=js&external"
export * from "./CardBankrollReduction.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports